import "../../../../content/projects/netwell/netwell.css";
import * as React from 'react';
export default {
  React
};